mutation ActivitySummarize($input: ActivitySummarizeInput!) {
    activitySummarize(input: $input) {
        activity {
            id
        }
    }
}
